import { useCallback, useEffect, useState } from "react";

/**
 * The "Sort by" choice of a list page, remembered per browser: "" (the page's own order), "field" (ascending) or
 * "-field" (descending), the form the API takes as `sort`.
 */
export function useSort(key: string, initial = "") {
  const storageKey = `crm.sort.${key}`;
  const [sort, setSortState] = useState<string>(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved !== null && /^-?[a-z_]*$/.test(saved)) return saved;
    } catch {
      // Storage unavailable: start from the default
    }
    return initial;
  });

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, sort);
    } catch {
      // Not critical
    }
  }, [storageKey, sort]);

  const setSort = useCallback((value: string | undefined | null) => setSortState(typeof value === "string" && /^-?[a-z_]*$/.test(value) ? value : ""), []);
  return { sort, setSort, reset: () => setSortState("") };
}
